<template>
  <div>
    <el-tabs type="border-card" v-model="activeName">
      <el-tab-pane :label="$l('tabs_tab_sample') || '样品资料'" name="sample">
        <tab-sample ref="tabsample" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('tabs_tab_elements') || '素材资料'"
        name="elements"
        lazy
      >
        <tab-elements ref="tabelements" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('tabs_tab_research') || '市场情报'"
        name="research"
        lazy
      >
        <tab-research ref="tabresearch" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import TabSample from "./components/main/sample/index.vue";
import TabElements from "./components/main/elements/index.vue";
import TabResearch from "./components/main/research/index.vue";

export default {
  name: "personal-myShoppingCart",
  components: {
    TabSample,
    TabElements,
    TabResearch,
  },
  data() {
    return {
      activeName: "sample",
    };
  },
};
</script>
